module.exports = __webpack_public_path__ + "0470e4d823c98a0fb421bfdb34873f47.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/es.json
// module id = 1040
// module chunks = 0